import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { Header } from "./components/Header";
import { Sidebar } from "./components/Sidebar";

import { setGlobalNavigate } from "./utils/navigation";

export const App: React.FC = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const navigate = useNavigate();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  useAuth();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (location.pathname === "/login" && token) {
      window.location.replace("/#/");
    }
  }, [location, navigate]);

  if (isLoginPage) {
    return (
      <div className="min-h-screen bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 p-6 bg-white dark:bg-gradient-to-br dark:from-[#0e0e14] dark:to-[#121820] overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
